import React, { useState } from "react"
import { View, ScrollView } from 'react-native';
import { useDispatch, useSelector } from "react-redux";
import styles from "../../../shared/styles";
import {Header,ButtonGroup,Label,Form} from "../../../components/SharedComponents";
import actions from "../../../actions";
import localize from "../../../shared/localize";


export default function CreateTeam(props) {
    const dispatch = useDispatch();
    const height = useSelector(({ setting }) => setting.height);

    const [state, setState] = useState({
        name: "",
        errorMessage: null,
        identity: 0     // 0 child ; 1 parent; 2 grandparent
    })

    const updateIndex = (index) => setState({ ...state, identity: index })

    const setUpnewFamily = async () => {
        setState({ ...state, errorMessage: null })
        let response = await dispatch(actions.setUpFamily(state.name, state.identity))
        if (response.status === 200) {
            return props.history.push("Join-family-success")
        }
        setState({ ...state, errorMessage: response.message });
    }


    return (
        <View style={styles.container}>
            {
                !global.isNative && (<Header title={localize.Create_Team} goBack={() => props.history.goBack()} />)
            }
            <ScrollView
                keyboardShouldPersistTaps="handled"
                style={[{ flex: 1, padding: 15 }, !global.isNative && { height: height - 70 }]}
            >
                <Label.PrimaryTitle>
                    {localize.Choose_a_name_for_your_family}
                </Label.PrimaryTitle>
                <View style={{ padding: 20 }} />
                <Form.TextInput
                    title={localize.create_family_team}
                    placeholder={localize.family_name}
                    value={state.name}
                    onChangeText={(text => setState({ ...state, name: text }))}
                    error={state.errorMessage}
                />
                <View style={{ padding: 10 }} />
                <Label.PrimaryCaption>
                {localize.my_family_role}
                </Label.PrimaryCaption>
                <ButtonGroup
                    buttons={[localize.child, localize.parent, localize.grandparent]}
                    selectedIndex={state.identity}
                    onPress={updateIndex}
                />
                <View style={{ padding: 20 }} />
                <Form.Button
                    title={localize.Create_and_Join}
                    onPress={setUpnewFamily}
                    disabled={state.name === "" || state.isLoading}
                />
            </ScrollView>
        </View>
    );
}